<div
  class="input-container"
  [attr.data-size]="size"
  [attr.data-disabled]="disabled"
  [attr.data-error]="error"
>
  @if (label) {
    <label class="input-label" [for]="inputId">
      {{ label }}
      @if (required) {
        <span class="required-indicator" aria-hidden="true">*</span>
      }
    </label>
  }

  <!-- Anchor for popover positioning -->
  <div class="time-picker-anchor">
    <div class="input-wrapper">
      <input
        class="input-field"
        type="text"
        inputmode="numeric"
        mask="Hh:m0"
        [keepCharacterPositions]="true"
        [dropSpecialCharacters]="false"
        [placeholder]="placeholder"
        [formControl]="inputControl"
        [attr.id]="inputId"
        [attr.name]="name"
        [attr.aria-label]="label || placeholder"
        [attr.aria-required]="required"
        [attr.aria-invalid]="error"
        [attr.aria-expanded]="isPopoverOpen"
        [attr.aria-haspopup]="'dialog'"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
      />

      <span
        class="input-icon input-icon-suffix"
        role="button"
        tabindex="0"
        aria-label="Open time picker"
        [attr.aria-expanded]="isPopoverOpen"
        (click)="onClockIconClick()"
        (keydown.enter)="onClockIconClick()"
        (keydown.space)="onClockIconClick()"
      >
        <umss-icon name="phosphorClock" [size]="iconSize" />
      </span>
    </div>

    <!-- Clock dropdown: fixed-position panel, managed entirely by time-picker -->
    @if (isPopoverOpen) {
      <div class="time-picker-dropdown" [ngStyle]="dropdownStyle">
        <umss-time-picker-clock
          [hours]="clockHours()"
          [minutes]="clockMinutes()"
          [view]="clockView()"
          (hourChange)="onHourChange($event)"
          (minuteChange)="onMinuteChange($event)"
          (viewChange)="onClockViewChange($event)"
        />
      </div>
    }
  </div>

  @if (helperText && !error) {
    <p class="helper-text">{{ helperText }}</p>
  }

  @if (error && errorMessage) {
    <p class="error-message">{{ errorMessage }}</p>
  }
</div>
